module.exports = __webpack_public_path__ + "img/undraw_review_fkgn.9a307af2.svg";